import { render, staticRenderFns } from "./NewUserDialog.vue?vue&type=template&id=d4b975aa&scoped=true&"
import script from "./NewUserDialog.vue?vue&type=script&lang=js&"
export * from "./NewUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewUserDialog.vue?vue&type=style&index=0&id=d4b975aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b975aa",
  null
  
)

export default component.exports